export default __webpack_public_path__ + "static/media/next-img.5a8a083f.svg";